module.exports = __webpack_public_path__ + "media/images/games/35gender/pink-fe9b1c25b015b199fede0339f9a40b42.png";